export default __webpack_public_path__ + "static/media/NB-K.e8d1a963.png";